import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useState } from 'react';
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import {RiFileExcel2Line} from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import './Reports.css'
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report195() {

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 544)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 544)
    const [Re195data, setRe195data] = useState([]);
    
    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }


    async function getR195() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res195 = await fetch("/api/BorrowReports/getV195", {
            method: 'POST',
            body: formData
        })
        const Re195data = await res195.json()
        setRe195data(Re195data.dataenum)
        console.log(Re195data)
    }

    const [Re195yeardata, setRe195yeardata] = React.useState([]);
    async function getR195year() {
        const res = await fetch("/api/BorrowReports/getyear195")
        const Re195yeardata = await res.json()
        setRe195yeardata(Re195yeardata.dataenum)
        console.log(Re195yeardata)
    }

    const chartdata = Re195data.map((item) => ({
        name: "ปีงบประมาณ"+ " " + item?.year,
        beRefundedAmt: item?.beRefundedAmt !=null ? item?.beRefundedAmt : "0",
        refundedAmt : item?.refundedAmt !=null ? item?.refundedAmt : "0",
      }));

      

    const y2 = Re195yeardata.filter(n => n.yearTh >= othYearSelected);

    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ปีงบประมาณ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ชำระคืนเงินกู้', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'ค้างชำระ', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'จำนวน (บริษัท)', colSpan: 5, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}, {}, { text: 'ค้างชำระ', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}],
    //     [{}, { text: 'จำนวนที่ต้องได้รับคืน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนเงินที่ได้รับคืน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ร้อยละ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'จำนวนเงินต้น', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ดอกเบี้ยผิดนัด', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ร้อยละ', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ถึงกำหนดชำระคืน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ชำระคืน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ปิดบัญชี', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ยังไม่ถึงกำหนดชำระคืน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ร้อยละชำระคืน', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'บริษัท', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ร้อยละ', fillColor: '#cccccc', bold: true, alignment: 'center' }]];
    //     Re195data.forEach(function (item) {
    //         var rowdata = [{ text: 'ปีงบประมาณ ' + thYearSelected, alignment: 'left' }, { text: (NumberWithCommas(item.beRefundedAmt)), alignment: 'right' }, { text: (NumberWithCommas(item.refundedAmt)), alignment: 'right' }, { text: item.per1, alignment: 'right' }, { text: (NumberWithCommas(item.principalAmt)), alignment: 'right' }, { text: (NumberWithCommas(item.interestDefault)), alignment: 'right' }, { text: item.per2, alignment: 'right' }, { text: item.dueCompany, alignment: 'right' }, { text: item.paymentCompany, alignment: 'right' }, { text: item.closeCompany, alignment: 'right' }, { text: item.notDueRepayment, alignment: 'right' }, { text: item.per3, alignment: 'right' }, { text: item.overdueAmt, alignment: 'right' }, { text: item.per4, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'สรุปข้อมูลการชำระคืนเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงาน', bold: true, alignment: 'center', fontSize: 18 },
    //             { text: 'ประจำปีงบประมาณ พ.ศ. '  + othYearSelected + ' ' + '-' + ' ' + thYearSelected, bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
    //                     body: tablebody
    //                 },
    //             }],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R195')
    // }


    React.useEffect(() => {
        getR195()
        getR195year()
    }, [thYearSelected, othYearSelected]);


    let sum1 = Re195data.reduce(function (prev, current) {
        return prev + +current.beRefundedAmt
    }, 0);
    let sum2 = Re195data.reduce(function (prev, current) {
        return prev + +current.refundedAmt
    }, 0);
    let sum3 = Re195data.reduce(function (prev, current) {
        return prev + +current.principalAmt
    }, 0);
    let sum4 = Re195data.reduce(function (prev, current) {
        return prev + +current.interestDefault
    }, 0);
    let sum5 = Re195data.reduce(function (prev, current) {
        return prev + +current.dueCompany
    }, 0);
    let sum6 = Re195data.reduce(function (prev, current) {
        return prev + +current.paymentCompany
    }, 0);
    let sum7 = Re195data.reduce(function (prev, current) {
        return prev + +current.closeCompany
    }, 0);
    let sum8 = Re195data.reduce(function (prev, current) {
        return prev + +current.notDueRepayment
    }, 0);
    let sum9 = Re195data.reduce(function (prev, current) {
        return prev + +current.overdueAmt
    }, 0);

    let sum10 = Re195data.reduce(function (prev, current) {
        return (sum2 * 100) / sum1
    }, 0);
    let sum11 = Re195data.reduce(function (prev, current) {
        return (sum4 * 100) / sum3
    }, 0);
    let sum12 = Re195data.reduce(function (prev, current) {
        return (sum6 * 100) / sum5
    }, 0);
    let sum13 = Re195data.reduce(function (prev, current) {
        return prev + +current.per4
    }, 0);




    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                        ปีงบประมาณ
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re195yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                    <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ข้อมูลปีงบประมาณ</span>
                    <Input 
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            if(e.target.value !== "กรุณาเลือก"){
                                setOThYearSelected(e.target.value)
                            } else {
                                return;
                            } 
                        }}
                    >
                        <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {Re195yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    
                    </Input>
                    <span className='header-select-year mx-3'>ถึง</span>
                    <Input 
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            if(e.target.value !== "กรุณาเลือก"){
                                setThYearSelected(e.target.value)
                            } else {
                                return;
                            } 
                        }}
                    >
                        <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div>

                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV195?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR195?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV195?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR195?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>


                <div className="report-wrapper">
                    <Table className="styled-table" bordered striped hover>
                        <thead className='styles-thead'>
                            <tr>
                                <th rowSpan="2">
                                    ปีงบประมาณ
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    ชำระคืนเงินกู้
                                </th>
                                <th colSpan="3" className=' text-center'>
                                    ค้างชำระ
                                </th>
                                <th colSpan="5" className=' text-center'>
                                    จำนวน(บริษัท)
                                </th>
                                <th colSpan="2" className=' text-center'>
                                    ค้างชำระ
                                </th>
                            </tr>
                            <tr>
                                <th className='text-center'>
                                    จำนวนเงินที่ต้องได้รับคืน
                                </th>
                                <th className='text-center'>
                                    จำนวนเงินที่ได้รับคืน
                                </th>
                                <th className='text-center'>
                                    ร้อยละ
                                </th>
                                <th className='text-center'>
                                    จำนวนเงินต้น
                                </th>
                                <th className='text-center'>
                                    ดอกเบี้ยผิดนัด
                                </th>
                                <th className='text-center'>
                                    ร้อยละ
                                </th>
                                <th className='text-center'>
                                    ถึงกำหนดชำระคืน
                                </th>
                                <th className='text-center'>
                                    ชำระคืน
                                </th>
                                <th className='text-center'>
                                    ปิดบัญชี
                                </th>
                                <th className='text-center'>
                                    ยังไม่ถึงกำหนดชำระ
                                </th>
                                <th className='text-center'>
                                    ร้อยละชำระคืน
                                </th>
                                <th className='text-center'>
                                    บริษัท
                                </th>
                                <th className='text-center'>
                                    ร้อยละ
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {Re195data.length > 0 && Re195data?.map((item, i) => (
                                <tr >
                                    <td className='text-start'>
                                        ปีงบประมาณ {item.year}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.beRefundedAmt)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.refundedAmt)}
                                    </td>
                                    <td className='text-end'>
                                        {item.per1.toFixed(2)}%
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.principalAmt)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(item.interestDefault)}
                                    </td>

                                    <td className='text-end'>
                                        {item.per2.toFixed(2)}%
                                    </td>
                                    <td className='text-end'>
                                        {item.dueCompany}
                                    </td>
                                    <td className='text-end'>
                                        {item.paymentCompany}
                                    </td>
                                    <td className='text-end'>
                                        {item.closeCompany}
                                    </td>
                                    <td className='text-end'>
                                        {item.notDueRepayment}
                                    </td>
                                    <td className='text-end'>
                                        {item.per3.toFixed(2)}%
                                    </td>
                                    <td className='text-end'>
                                        {item.overdueAmt}
                                    </td>
                                    <td className='text-end'>
                                        {item.per4.toFixed(2)}%
                                    </td>
                                </tr>

                            )) ||
                                <tr>
                                    <td colSpan="14" rowSpan="6" className='text-center'>ไม่มีข้อมูลในระบบ</td>
                                </tr>
                            }
                        </tbody>
                        {Re195data.length > 0 ?(
                            <tfoot>
                                <tr>
                                    <th scope="row" className='text-end'>
                                        รวมทั้งสิ้น
                                    </th>
                                    <td className='text-end'>
                                        {NumberWithCommas(sum1)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(sum2)}
                                    </td>
                                    <td className='text-end'>
                                        {sum10.toFixed(2)}%
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(sum3)}
                                    </td>
                                    <td className='text-end'>
                                        {NumberWithCommas(sum4)}
                                    </td>
                                    <td className='text-end'>
                                        {sum11.toFixed(2)}%
                                    </td>
                                    <td className='text-end'>
                                        {sum5}
                                    </td>
                                    <td className='text-end'>
                                        {sum6}
                                    </td>
                                    <td className='text-end'>
                                        {sum7}
                                    </td>
                                    <td className='text-end'>
                                        {sum8}
                                    </td>
                                    <td className='text-end'>
                                        {sum12.toFixed(2)}%
                                    </td>
                                    <td className='text-end'>
                                        {sum9}
                                    </td>
                                    <td className='text-end'>
                                        {sum13.toFixed(2)}%
                                    </td>
                                </tr>
                            </tfoot>
                        ):null}
                        
                    </Table>
                </div>

                <div className='mt-5 w-100 d-flex align-items-center justify-content-center'>
                <BarChart
                    width={1300}
                    height={300}
                    data={chartdata}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Bar name="ชำระคืนเงินกู้ จำนวนเงินที่ต้องได้รับคืน" dataKey="beRefundedAmt" fill="#0A72FF"/>
                    <Bar name="ชำรคืนเงินกู้ จำนวนเงินที่ได้รับคืน" dataKey="refundedAmt" fill="#0AB1FF" />
                </BarChart>
            </div>

            </div>

        </Container>
    );


}